import React from "react";
import "../Stepmintmobile/css/stepmintmobile.css";

import { Container, Row, Col } from "react-bootstrap";
import { Zoom } from "react-reveal";
import "../Stepmintmobile/css/mobilefooter.css";

const Stepmint = () => {
  return (
    <>
      <div className="position-relative">
        <div className="sm-cp1"></div>
        <div className="sm-cp2"></div>
        <div className="sm-cp3"></div>
        <div className="sm-cp4"></div>
        <div className="sm-cp5"></div>
      <section className=" text-white  py-5">
        <Container>
          <div className="d-flex flex-column align-items-center">
            <img src="assets\images\mobile01.png" alt="" />
            <h2 style={{ color: "#53CFD2", fontWeight: 700 }}>
              How Stepmint Works
            </h2>
            <p className="sm-p">
              StepMint offers a straightforward way to participate in the NFT
              space and  generate steprewards. Here's a breakdown of how it
              works:
            </p>
          </div>
          <br />
          <br />
          <div>
            <h3 className="mb-2 sm-h" style={{ color: "#53CFD2", fontWeight: 700 }}>
              Subscription
            </h3>
            <br />
            <Row>
              <Col lg={7} className="">
                <div className="mobile-subscription px-3">
                  <ul className="mb-0 py-4 ">
                    <li>
                      NFT Box Subscriptions: Subscribe NFT Boxes at your
                      convenience.
                    </li>
                    <li>
                      Minimum Subscriptions: The minimum Subscriptions is $100.
                    </li>
                    <li>
                      Subscription Enhancement: You can subscribe to any value
                      above $100, provided it's in multiples of $100 (e.g.,
                      $300, $800, $1200).
                    </li>
                    <li>
                      Subscriptions Range: Packages range from $100 to an
                      infinite value, allowing flexibility for all Subscribers.
                    </li>
                    <li>
                      Reward Token: You'll receive rewards in Mr Mint tokens.
                    </li>
                  </ul>
                </div>
              </Col>
              <Col
                lg={5}
                className="d-flex place-item-center justify-content-center"
              >
                <img
                  className=" img-fluid"
                  src="assets/images/nftbox1.svg "
                  alt=""
                  style={{ minWidth: 240 }}
                />
              </Col>
            </Row>
          </div>

          <br />
          <br />
          <div>
            <h3 style={{ color: "#53CFD2", fontWeight: 700 }}>STEP REWARDS</h3>
            <p>Your rewards depend on your total Subscriptions tier</p>

            <Row className="gy-3">
              <Col>
                <div className="step-card-2 p-4">
                  <p className="step-card">Silver Sprint</p>
                  <hr />
                  <Row>
                    <Col>
                      <p className="step-detail mb-0">Subscription Range</p>
                    </Col>
                    <Col>
                      <p className="step-detail mb-0 text-end">$100 - $900</p>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <p className="step-detail mb-0">% Reward</p>
                    </Col>
                    <Col>
                      <p className="step-detail mb-0 text-end">0.5%</p>
                    </Col>
                  </Row>
                  <div className="nft-detail-block  mt-4 px-2">
                    <Row className="gy-2 p-2">
                      <Col
                        lg={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <h6
                            className="mb-1"
                            style={{ fontWeight: 700, color: "#00FF26" }}
                          >
                            Booster %
                          </h6>
                          <small style={{ fontSize: 12 }}>
                            Reward After 1st Referral
                          </small>
                        </div>
                        <div className="text-end">
                          <h5>0.55%</h5>
                          <small style={{ fontSize: 12 }}>
                            On Same or Above
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="nft-detail-block  mt-3 px-2">
                    <Row className="gy-2 p-2">
                      <Col
                        lg={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <h6
                            className="mb-1"
                            style={{ fontWeight: 700, color: "#00FF26" }}
                          >
                            Booster %
                          </h6>
                          <small style={{ fontSize: 12 }}>
                            Reward After 1st Referral
                          </small>
                        </div>
                        <div className="text-end">
                          <h5>0.60%</h5>
                          <small style={{ fontSize: 12 }}>
                            On Same or Above
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="step-card-2 p-4">
                  <p className="step-card">Gold Sprint</p>
                  <hr />
                  <Row>
                    <Col>
                      <p className="step-detail mb-0">Subscription Range</p>
                    </Col>
                    <Col>
                      <p className="step-detail mb-0 text-end">$1000 - $9000</p>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <p className="step-detail mb-0">% Reward</p>
                    </Col>
                    <Col>
                      <p className="step-detail mb-0 text-end">0.6%</p>
                    </Col>
                  </Row>
                  <div className="nft-detail-block  mt-4 px-2">
                    <Row className="gy-2 p-2">
                      <Col
                        lg={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <h6
                            className="mb-1"
                            style={{ fontWeight: 700, color: "#00FF26" }}
                          >
                            Booster %
                          </h6>
                          <small style={{ fontSize: 12 }}>
                            Reward After 1st Referral
                          </small>
                        </div>
                        <div className="text-end">
                          <h5>0.65%</h5>
                          <small style={{ fontSize: 12 }}>
                            On Same or Above
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="nft-detail-block  mt-3 px-2">
                    <Row className="gy-2 p-2">
                      <Col
                        lg={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <h6
                            className="mb-1"
                            style={{ fontWeight: 700, color: "#00FF26" }}
                          >
                            Booster %
                          </h6>
                          <small style={{ fontSize: 12 }}>
                            Reward After 1st Referral
                          </small>
                        </div>
                        <div className="text-end">
                          <h5>0.70%</h5>
                          <small style={{ fontSize: 12 }}>
                            On Same or Above
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="step-card-2 p-4">
                  <p className="step-card">Diamond Sprint</p>
                  <hr />
                  <Row>
                    <Col>
                      <p className="step-detail mb-0">Subscription Range</p>
                    </Col>
                    <Col>
                      <p className="step-detail mb-0 text-end">
                        $10,000 - Unlimited
                      </p>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <p className="step-detail mb-0">% Reward</p>
                    </Col>
                    <Col>
                      <p className="step-detail mb-0 text-end">0.7%</p>
                    </Col>
                  </Row>
                  <div className="nft-detail-block  mt-4 px-2">
                    <Row className="gy-2 p-2">
                      <Col
                        lg={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <h6
                            className="mb-1"
                            style={{ fontWeight: 700, color: "#00FF26" }}
                          >
                            Booster %
                          </h6>
                          <small style={{ fontSize: 12 }}>
                            Reward After 1st Referral
                          </small>
                        </div>
                        <div className="text-end">
                          <h5>0.75%</h5>
                          <small style={{ fontSize: 12 }}>
                            On Same or Above
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="nft-detail-block  mt-3 px-2">
                    <Row className="gy-2 p-2">
                      <Col
                        lg={12}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <h6
                            className="mb-1"
                            style={{ fontWeight: 700, color: "#00FF26" }}
                          >
                            Booster %
                          </h6>
                          <small style={{ fontSize: 12 }}>
                            Reward After 1st Referral
                          </small>
                        </div>
                        <div className="text-end">
                          <h5>0.80%</h5>
                          <small style={{ fontSize: 12 }}>
                            On Same or Above
                          </small>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <br />
          <br />

          <Row className="gy-3">
            <Col lg={6}>
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                  Step Reward Calculation
                </h3>
                <p className="mb-0">
                  For example, a $500 Subscribers earns a 0.50% daily reward,
                  which equals $2.50.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                  Plan Duration
                </h3>
                <p className="mb-0">
                  Each Subscriptions plan lasts for one year. i.e. 365 days from
                  date of subscription
                </p>
              </div>
            </Col>
          </Row>
          <br />
          <Row className="align-items-stretch gy-3">
            <Col lg={6} className="d-flex">
              <div className="step-card-2 p-4 w-100 d-flex flex-column justify-content-start">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                  Mr Mint Conversion
                </h3>
                <p className="mb-0">
                  Your dollar reward is converted into Mr Mint Token based on
                  the current Mr Mint market price. For example, if Mr Mint is
                  priced at $0.10, a $2.50 reward would give you 25 Mr Mint
                  Tokens daily.
                </p>
              </div>
            </Col>

            <Col lg={6} className="d-flex">
              <div className="step-card-2 p-4 w-100 d-flex flex-column justify-content-between">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                  Staggered Subscriptions
                </h3>
                <p className="mb-0">
                  If you purchase a $500 plan on April 1st and a $1500 plan on
                  April 15th, your reward is calculated based on your total
                  Subscriptions of $2,000. After one year, on April 1st, 2026,
                  the first plan expires, and your rewards will be adjusted
                  accordingly.
                </p>
              </div>
            </Col>
          </Row>

          <br />
          <br />
          <h3 style={{ color: "#53CFD2", fontWeight: 700 }}>
            Referral and Matching Bonuses
          </h3>
          <br />
          <Row>
            <Col lg={6}>
              <div className="step-card-2 h-100  p-4 d-flex flex-column w-100 justify-content-center align-items-center">
                <img
                  className=" img-fluid"
                  src="assets/images/icon03.png "
                  alt=""
                  style={{ width: 246, height: 238 }}
                />
                <h3
                  className="mt-3"
                  style={{ color: "white", fontWeight: 700 }}
                >
                  Booster Reward Levels
                </h3>
                <ul className="mb-0 py-4 ">
                  <li>
                    Referring a user with $1000 or above increases your reward
                    to 0.65% (instead of 0.60%).
                  </li>
                  <li>
                    Referring two users with $1000 or above increases your
                    reward to 0.70%.
                  </li>
                  <li>
                    Booster Levels: The booster reward applies up to two levels.
                  </li>
                  <li>
                    Vesting Wallet: Booster rewards are deposited into your
                    Vesting Wallet.
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={6}>
              <div className="w-100 d-flex justify-content-center">
                <img
                  className=" img-fluid"
                  src="assets/images/icon2.png "
                  alt=""
                  style={{ minWidth: 200 }}
                />
              </div>
            </Col>
          </Row>
          <br />
          <br />
          <Row className="gy-3">
            <Col lg={6} className="d-flex flex-column gap-3">
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                  Referral Bonus
                </h3>
                <p className="mb-0">
                  Earn a 5% referral bonus when you introduce a new subscriber
                  to the Stepmint community.
                </p>
              </div>
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                  Matching Bonus
                </h3>
                <p className="mb-0">
                  Receive an 8% matching bonus on Subscriptions made by your
                  referrals.
                </p>
              </div>
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                  Business Wallet
                </h3>
                <p className="mb-0">
                  Referral and matching bonuses are deposited into your Business
                  Wallet.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="step-card-2 p-4 d-flex flex-column w-100 justify-content-center align-items-center">
                <img
                  className=" img-fluid"
                  src="assets/images/icon05.svg "
                  alt=""
                  style={{ width: 246, height: 238 }}
                />
                <h3
                  style={{ color: "white", fontWeight: 700 }}
                  className="mt-3"
                >
                  Booster Rewards
                </h3>
                <p className="mb-0 text-center">
                  Eligibility: When you subscribe to $100 or more, and refer to
                  another user who subscribes $100 or more, you become eligible
                  for a booster reward.
                </p>
              </div>
            </Col>
          </Row>
            <br />
            <br />
          <Row>
          <Col lg={6}>
              <div className=" p-4 d-flex flex-column w-100 justify-content-center align-items-center">
                <img
                  className=" img-fluid"
                  src="assets/images/hiw05.png "
                  alt=""
                  style={{ width: 246, height: 238 }}
                />
                <h3
                  style={{ color: "white", fontWeight: 700 }}
                  className="mt-3"
                >
                  Wallets & Withdraws
                </h3>
                <p className="mb-0 text-center">
                There will be 3 separate wallets in our App & Dapp
                </p>
              </div>
            </Col>
            <Col lg={6} className="d-flex flex-column gap-3">
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                StepMint Wallet
                </h3>
                <p className="mb-0">
                100% of per day Step Rewards earned through NFT Box  will be credited to StepMint Wallet.
                </p>
              </div>
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                Business Wallet
                </h3>
                <p className="mb-0">
                Referral Rewards and Community Rewards will be credited (100%) in Business Wallet.
                </p>
              </div>
              <div className="step-card-2 p-4">
                <h3 style={{ color: "white", fontWeight: 700 }}>
                Vesting Wallet
                </h3>
                <p className="mb-0">
                Booster Rewards earned per day through Step Rewards will be Credited to Vesting Wallet.
                </p>
              </div>
            </Col>
            
          </Row>
          <br />
          <br />
          <div className="mobile-subscription px-3">
                  <ul className="mb-0 py-4 ">
                    <li>
                    StepMint Wallet Withdrawals can be made once every 168 hours with the withdrawal amount of minimum of 100 MNT and a maximum of 1500 MNT.
                    </li>
                    <li>
                    Business Wallet Withdrawals can be made once every 24 hours with the withdrawal amount of minimum of 100 MNT and a maximum of 1500 MNT.
                    </li>
                    <li>
                    The 168-hour and 24-hour withdrawal windows begin at the exact time a StepMint Withdrawal or Business Withdrawal request is submitted. Withdrawal requests may take 24 to 48 hours for approval and processing.
                    </li>
                    <li>
                    Funds deposited into the Vesting Wallet will be released exactly 365 days after the date of deposit.
                    </li>
                    <li>
                    Withdrawals can be initiated from any one wallet once in 24 hours.
                    </li>
                  </ul>
                </div>
        </Container>
      </section>
      </div>

      {/* <Mobilefooter /> */}
    </>
  );
};
export default Stepmint;
